import { useEffect, useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import './BoldCheckoutButton.css';

const BoldCheckoutButton = ({
  isShippingInfoValid,
  isShippingMethodValid,
  isCartValid,
  isSummaryValid,
  isCustomerNoteValid,
}) => {
  const containerRef = useRef(null);
  const scriptRef = useRef(null);

  const cart = useSelector(state => state.cart);
  const cartItems = cart?.items || [];
  const totalAmount = useSelector((state) => state.checkout?.orderSummary?.total || 0);
  const userId = useSelector((state) => state.auth?.user?.id);

  const [orderId, setOrderId] = useState(null);
  const [checkoutHash, setCheckoutHash] = useState(null);
  const [readyToRender, setReadyToRender] = useState(false);
  //const [ngrokRedirectUrl, setNgrokRedirectUrl] = useState(null);

  const API_KEY = import.meta.env.VITE_BOLD_API_KEY_PROD;
  const BACKEND_URL = import.meta.env.VITE_API_URL;
  console.log('🔍 BACKEND_URL:', BACKEND_URL);
  //const REDIRECTION_URL = import.meta.env.VITE_DOMAIN_VPA;
  //console.log('🔍 REDIRECCION DE BOLD', REDIRECTION_URL);
  const redirectionUrl = `${BACKEND_URL}/api/payment-result`;
  console.log('🔍 URL de redirección para Bold:', redirectionUrl);

  const isFormValid =
    isShippingInfoValid &&
    isShippingMethodValid &&
    isCartValid &&
    isSummaryValid &&
    isCustomerNoteValid;

  useEffect(() => {
    if (import.meta.env.DEV) {
      const obtenerNgrokUrl = async () => {
        try {
          const res = await fetch(`${BACKEND_URL}/ngrok/url`);
          const data = await res.json();
          if (data.frontend) {
            //setNgrokRedirectUrl(`${data.frontend}/checkout/payment-result`);
            console.log('🌐 URL de ngrok (frontend):', data.frontend);
          }
        } catch (err) {
          console.warn('⚠️ No se pudo obtener URL de ngrok:', err);
        }
      };
      obtenerNgrokUrl();
    }
  }, []);

  useEffect(() => {
    if (!API_KEY) {
      console.warn('⚠️ VITE_BOLD_API_KEY no está definido.');
    }
  }, [API_KEY]);

  useEffect(() => {
    if (!isFormValid || totalAmount <= 0 || !userId || cartItems.length === 0) return;

    const crearOrden = async () => {
      try {
        const monto = Math.floor(totalAmount); // ✅ Ya está en COP

        const res = await fetch(`${BACKEND_URL}/checkout/crear-orden`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            monto,
            divisa: 'COP',
            userId,
            cartItems,
          }),
        });

        if (!res.ok) {
          const errorText = await res.text();
          throw new Error(`Error ${res.status}: ${errorText}`);
        }

        const data = await res.json();
        if (data.orderId && data.hash) {
          setOrderId(data.orderId);
          setCheckoutHash(data.hash);
          console.log('🆔 Orden creada:', data.orderId);
          console.log('🔐 Hash:', data.hash);
        }
      } catch (err) {
        console.error('❌ Error al crear orden:', err);
      }
    };

    crearOrden();
  }, [isFormValid, totalAmount, userId, cartItems]);

  useEffect(() => {
    const ready =
      isFormValid && orderId && checkoutHash && totalAmount > 0 && API_KEY;
    setReadyToRender(!!ready);
  }, [isFormValid, orderId, checkoutHash, totalAmount, API_KEY]);

  useEffect(() => {
    if (!readyToRender) return;

    const container = containerRef.current;
    if (!container) return;

    try {
      if (scriptRef.current && container.contains(scriptRef.current)) {
        container.removeChild(scriptRef.current);
      }
    } catch (err) {
      console.warn('⚠️ Error eliminando el script:', err);
    }

    container.innerHTML = '';

    const amountCOP = Math.floor(totalAmount).toString(); // ✅ Ya en COP

    const attrs = {
      'data-bold-button': 'dark-L',
      'data-order-id': orderId,
      'data-currency': 'COP',
      'data-amount': amountCOP,
      'data-api-key': API_KEY,
      'data-redirection-url': redirectionUrl,
      'data-description': 'Compra en Mi Comercio',
      'data-integrity-signature': checkoutHash,
      'data-extra-data-1': 'Información extra 1',
    };

    const script = document.createElement('script');
    Object.entries(attrs).forEach(([k, v]) => script.setAttribute(k, v));
    script.src = 'https://checkout.bold.co/library/boldPaymentButton.js';
    script.async = true;

    container.appendChild(script);
    scriptRef.current = script;

    console.log('📦 Atributos del botón Bold:', attrs);
  }, [readyToRender, totalAmount]);

  return (
    <div className="text-center mt-5">
      <h2>Completa tu pago</h2>
      {!readyToRender ? (
        <div className="d-flex justify-content-center align-items-center mt-3">
          <div className="spinner-border text-secondary me-2" role="status" />
          <span className="text-muted">Preparando tu botón de pago...</span>
        </div>
      ) : (
        <>
          <p className="ts text-success">✔️ Botón listo. Puedes proceder al pago.</p>
          <div className='btn-bold' id="bold-checkout-button" ref={containerRef}></div>
        </>
      )}
    </div>
  );
};

export default BoldCheckoutButton;
